<ion-header [translucent]="true" class="ion-no-border">
  <ion-toolbar color="light">
    <ion-avatar slot="start">
      <img 
      [src]="group.image">
    </ion-avatar>
    
    <ion-label slot="start">
      <div>Benvenuti nel canale</div>
      <div style="font-size: 1.2rem; font-weight: bold;">{{group.name}}</div>
    </ion-label>
    <!-- <div
      style="display: flex; align-items: center; font-family: omnes-pro, sans-serif;font-weight: 700;letter-spacing: -1px; padding: 16px">
      <img src="../../assets/icon/icon.png" height="28px" />
      <ion-label style="font-size: 32px; margin-left:8px; margin-top: -4px" color="primary">Tempo</ion-label>
    </div>
    
    </ion-buttons> -->
    <ion-buttons *ngIf="fromMenu" slot="end">
      <ion-button (click)="this.modalController.dismiss()">
        <ion-icon name="close" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content *ngIf="ready" [fullscreen]="true">
  
  <div style="padding: 16px; background-color: var(--ion-color-light);">Documenti</div>
  <div>
    <ion-item (click)="showGroupPrivacy()" style="font-size: 1.2rem">
      <ion-icon name="document-lock-outline"></ion-icon>
      <ion-label style="margin-left: 12px;">Informativa privacy {{group.name}}</ion-label>
      <ion-button fill="clear" slot="end">LEGGI</ion-button>
    </ion-item>

    <!-- <ion-item *ngIf="group.gid!=1" (click)="showGroupPrivacy()" style="font-size: 1.2rem">
      <ion-icon name="document-lock-outline"></ion-icon>
      <ion-label style="margin-left: 12px;">Informativa privacy {{group.name}}</ion-label>
      <ion-button fill="clear" slot="end">LEGGI</ion-button>
    </ion-item> -->

    <div style="padding: 16px; background-color: var(--ion-color-light); font-weight: 500;">Il/La sottoscritto/a
      dichiara con la presente</div>

    <ion-item *ngIf="group.custom_privacy" lines="none">
      <ion-label style="font-size: 1.1rem;"><strong>Presta il consenso a tutto</strong></ion-label>
      <ion-checkbox (ionChange)="acceptAll()" name="acceptAllValue" [(ngModel)]="acceptAllValue" aria-label=""
        slot="end"></ion-checkbox>
    </ion-item>

    <!-- <ion-item [color]="userPrivacy.informativa ? 'success' : 'danger'">
      <ion-label>
        <ion-label><strong><i>Obbligatorio</i></strong></ion-label>
        di aver preso visione dell’informativa sul trattamento dei dati
        personali fornitami dal Titolare del trattamento. (<a
          (click)="group.gid == 1 ? showPrivacy() : showGroupPrivacy()">LEGGI</a>)
      </ion-label>
      <ion-checkbox [disabled]="fromMenu" [(ngModel)]="userPrivacy.informativa" aria-label="" slot="end"></ion-checkbox>
    </ion-item> -->


    <div *ngIf="group.custom_privacy">
      <ion-item [color]="gpc.mandatory && (getUserPrivacyConsentValue(gpc) ? 'success' : 'danger')" *ngFor="let gpc of gprivacyConsent">
        <ion-label>
          <ion-label *ngIf="gpc.mandatory"><strong><i>Obbligatorio</i></strong></ion-label>
          {{gpc.label}}
        </ion-label>
        <ion-checkbox (ionChange)="consentChanged($event, gpc)" [disabled]="fromMenu && gpc.mandatory" [checked]="getUserPrivacyConsentValue(gpc)" aria-label="" slot="end"></ion-checkbox>
      </ion-item>



      <!-- <ion-item>
        <ion-label>
          <ion-label color="danger" *ngIf="group.gid != 1"><strong><i>obbligatorio per l'iscrizione al canale
                {{group.name}}</i></strong></ion-label>
          di prestare il proprio consenso alla comunicazione dei propri dati personali ai soggetti partner di Tempo,
          così
          come indicato al punto 2.5 della sezione Finalità del trattamento.
        </ion-label>
        <ion-checkbox [(ngModel)]="userPrivacy.partner" aria-label="" slot="end"></ion-checkbox>
      </ion-item>
      
      <ion-item>
        <ion-label>
          di prestare il proprio consenso alla profilazione dei propri dati personali e del proprio profilo utente così
          come indicato al punto 2.3 della sezione Finalità del trattamento.
        </ion-label>
        <ion-checkbox [(ngModel)]="userPrivacy.profilazione" aria-label="" slot="end"></ion-checkbox>
      </ion-item>
      
      <ion-item lines="none">
        <ion-label>
          di prestare il proprio consenso alla ricezione di comunicazioni commerciali da parte di Tempo, così come
          indicato al punto 2.7 della sezione Finalità del trattamento.
        </ion-label>
        <ion-checkbox [(ngModel)]="userPrivacy.commerciali" aria-label="" slot="end"></ion-checkbox>
      </ion-item> -->
    </div>

    <div *ngIf="group.gid==1">
      <div style="padding: 16px; background-color: var(--ion-color-light); font-weight: 500;">Termini di utilizzo</div>
      <ion-item [color]="userPrivacy.termini ? 'success' : 'danger'" style="font-size: 1.2rem">
        <ion-label>
          <ion-label><strong><i>Obbligatorio</i></strong></ion-label>
          di aver preso visione dei Termini e Condizioni (<a (click)="showTerms()">LEGGI</a>)
        </ion-label>
        <ion-checkbox slot="end" [disabled]="fromMenu" [(ngModel)]="userPrivacy.termini" aria-label=""
          slot="end"></ion-checkbox>
      </ion-item>
    </div>


  </div>


</ion-content>

<ion-footer *ngIf="!fromMenu" class="ion-no-border">
  <ion-toolbar color="light">
    <ion-label *ngIf="!mandatoryRead" slot="start">
      Per proseguire <a (click)="showGroupPrivacy()">LEGGI</a> l'informativa
    </ion-label>
    <ion-spinner slot="start" *ngIf="checkingData"></ion-spinner>
    <ion-button style="margin-right: 16px;" slot="end" [color]="!dataIsReady() || checkingData ? 'medium' : 'success'"
      [disabled]="!dataIsReady() || checkingData" (click)="updatePrivacy()">{{fromMenu ? "Aggiorna" :
      "Continua"}}</ion-button>
  </ion-toolbar>
</ion-footer>

<ion-footer *ngIf="fromMenu" class="ion-no-border">
  <ion-toolbar color="light">
    <ion-button [disabled]="!dataIsReady() || checkingData" style="margin-right: 16px;" slot="end" (click)="updateConsents()">Aggiorna</ion-button>
  </ion-toolbar>
</ion-footer>